import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { GETTING_RESULTS, GET_RESULTS, RESULTS_ERROR } from "../types"

export const fetchResults = (filterString, page, perPage) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `${baseUrl}/student-results?expand=student,term,academicSession,class`

        if(filterString && filterString !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filterString}`
        }

        if(page && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_RESULTS,
            payload: true
        })

        const response = await axios.get(url, { headers })

        dispatch({
            type: GET_RESULTS,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: RESULTS_ERROR,
            error
        })
    }
}